import React from 'react';
import { GameData } from "../share/game-data.js";
import * as ICONS from "../other/icons.js";
import * as util from "../other/util.js";

// A compact, in-text, sparse view for resources
export default class CompactResourcesView extends React.Component {
    render() {
        const available = this.props.availableResources || {};
        const resources = this.props.resources ? Object.entries(this.props.resources).filter(e => e[1] > 0) : [];
        const energy_stats = this.props.energy_stats;

        return (
            <span>
                {energy_stats && energy_stats.amount > 0 ? <EnergyResource key="energy" energyStats={energy_stats} /> : null}
                {resources.map((resource, idx) =>
                    <NormalResource key={idx} resource_id={resource[0]} amount={resource[1]} available={available[resource[0]]} />
                )}
            </span>);
    }
}

class EnergyResource extends React.Component {
    render() {
        const energy_stats = this.props.energyStats;
        const available = energy_stats.production - energy_stats.consumption;
        let color = undefined;
        if (available != null && available < energy_stats.amount) {
            color = "orange";
        }

        return <SingleResource ui_name={"Energy"} icon_id={"energy"} amount={energy_stats.amount} color={color} />
    }
}

class NormalResource extends React.Component {
    render() {
        const resource_id = this.props.resource_id;
        const amount = this.props.amount;
        const available = this.props.available;
        const resource = GameData.RESOURCE_BY_ID[resource_id];

        let color = undefined;
        if (available != null && available < amount) {
            color = "red";
        }

        return <SingleResource ui_name={resource.ui_name} icon_id={resource.id} amount={amount} color={color} />
    }
}

class SingleResource extends React.Component {
    render() {
        return (<span style={{ textAlign: "right" }}>
            <util.ShortNumber number={this.props.amount} style={{ color: this.props.color }} />
            <span> </span>
            <util.Tooltip tooltip={this.props.ui_name}>
                <img src={ICONS.RESOURCES[this.props.icon_id]} alt={this.props.ui_name + "|"} style={{ height: "24px", paddingRight: "10px" }} />
            </util.Tooltip>
        </span>);
    }
}
